import React, { useState } from 'react'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import styles from '../../../styles'
import { newsEnum } from '../../../enums/newsEnum'
import { FormattedMessage } from 'react-intl'
import SvgBottomArrow from '../../../icons/BottomArrow'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import Link from 'react-scroll/modules/components/Link'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			breadcrumbContainerStyle: {
				padding: 25,

				'&::before': {
					display: 'none'
				}
			},
			selected: {
				borderLeft: `3px solid ${theme.palette.dynamic.main}`
			}
		}
	)
)

interface AcceptingProps {
	offset: number
}

type BreadcrumbProps = AcceptingProps

const Breadcrumb: React.FC<BreadcrumbProps> = (
	{
		offset
	}
) => {
	const classes = useStyle()
	const theme = useTheme()
	const [selected, setSelected] = useState(newsEnum.actualite_exploitation)

	const breadcrumbContainerClass: ClassValue = classNames(
		classes.backgroundWhite,
		classes.breadcrumbContainerStyle,
		classes.flex,
		classes.flexBetween,
		classes.alignCenter,
		classes.cursorPointer
	)

	const breadcrumSelected: ClassValue = classNames(
		breadcrumbContainerClass,
		classes.selected
	)

	const textClass: ClassValue = classNames(
		classes.text2_opacity,
		classes.colorBlue
	)

	const changeSelectedElement = (elementSelected: any) => {
		setSelected(elementSelected)
	}

	return (
		<>
			{
				Object.keys(newsEnum).map(
					(newsType) => (
						<Link
							key={newsType}
							className={newsType === selected ? breadcrumSelected : breadcrumbContainerClass}
							spy
							to={newsType}
							smooth
							offset={-offset}
							onSetActive={changeSelectedElement}
						>
							<span className={textClass}>
								<FormattedMessage
									id={`news.breadcrumb.${newsType}`}
									defaultMessage="Informations pratiques"
									description="Breadcrumb text"
								/>
							</span>

							<SvgBottomArrow color={theme.palette.blue.main} />
						</Link>
					)
				)
			}
		</>
	)

}

export default Breadcrumb
